import { authApi } from "./index";

export const getAllCommunities = async (category, search) => {
  try {
    const params = {};
    if (category) params.category = category;
    if (search) params.search = search;
    const response = await authApi.get("/Community", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCommunityDetail = async (idOrSlug) => {
  try {
    const response = await authApi.get(`/Community/${idOrSlug}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const checkCommunityAccess = async (communityId) => {
  try {
    const response = await authApi.get(`/Community/${communityId}/check-access`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const joinCommunity = async (communityId) => {
  try {
    const response = await authApi.post(`/Community/${communityId}/join`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const leaveCommunity = async (communityId) => {
  try {
    const response = await authApi.post(`/Community/${communityId}/leave`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCommunityMembers = async (communityId, page = 1, pageSize = 50) => {
  try {
    const response = await authApi.get(`/Community/${communityId}/members`, {
      params: { page, pageSize },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCommunityPosts = async (communityId, page = 1, pageSize = 20) => {
  try {
    const response = await authApi.get(`/Community/${communityId}/posts`, {
      params: { page, pageSize },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createCommunityPost = async (communityId, postData) => {
  try {
    const response = await authApi.post(`/Community/${communityId}/posts`, postData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteCommunityPost = async (postId) => {
  try {
    const response = await authApi.delete(`/Community/posts/${postId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addCommunityComment = async (postId, commentData) => {
  try {
    const response = await authApi.post(`/Community/posts/${postId}/comments`, commentData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteCommunityComment = async (commentId) => {
  try {
    const response = await authApi.delete(`/Community/comments/${commentId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
